const { safeReturnPath } = require('../sso/auth-flow');

const LOGIN_RETURN_PATH_KEY = 'keilog.login-return-path';

/**
 * The protected page a signed-out visit asked for, kept until the sign-in that follows.
 *
 * Without it every sign-in lands on the role's default page, so a link into KEiLOG — RAH's
 * 「KEiLOG で開く」 opens /trial/customer/update/:id — only works once the tab already has a
 * session. sessionStorage because the value must survive this tab's SSO round trip (broker and
 * back, same tab) and must never steer a sign-in in another tab. It works with SSO off as well,
 * which is why it is not keyed by the SSO site like the active-sync return path.
 */
function rememberLoginReturnPath(storage, requestedPath, origin = window.location.origin) {
	const path = safeReturnPath(requestedPath, origin);
	if (!path) return false;
	try {
		storage.setItem(LOGIN_RETURN_PATH_KEY, path);
		return true;
	} catch (error) {
		// Blocked storage only loses the redirect; sign-in still lands on the default page.
		return false;
	}
}

/** One-shot: reading clears it, and a value that fails validation is dropped, not followed. */
function takeLoginReturnPath(storage, origin = window.location.origin) {
	let value = null;
	try {
		value = storage.getItem(LOGIN_RETURN_PATH_KEY);
		storage.removeItem(LOGIN_RETURN_PATH_KEY);
	} catch (error) {
		return null;
	}
	return safeReturnPath(value, origin);
}

module.exports = { rememberLoginReturnPath, takeLoginReturnPath };
